'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var tslib = require('tslib');
var signup = require('@gig/magic-sdk/dist/adapter/users/signup');

function twoFactor() {
    var _this = this;
    return {
        id: 'two-factor-wrapper',
        component: 'div',
        isDataField: false,
        properties: {
            class: 'two-factor-authentication',
        },
        children: [
            {
                id: 'two-factor',
                component: 'magic-ui-switch',
                isDataField: true,
                testId: 'step-2-2FA',
                properties: {
                    class: 'switch',
                    right: true,
                },
                v: {
                    html: magicCommon.translate('sign-up-step-two.two-factor.link'),
                },
                preloadProperties: function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                    return tslib.__generator(this, function (_a) {
                        return [2 /*return*/, {
                                value: 'false',
                            }];
                    });
                }); },
                converter: function (formValue) {
                    var authenticationMethod = formValue['two-factor'].value === true
                        ? signup.AuthenticationMethod.TWO_FACTOR_BY_SMS
                        : signup.AuthenticationMethod.ONE_FACTOR;
                    return { authenticationMethod: authenticationMethod };
                },
            },
        ],
    };
}

exports.twoFactor = twoFactor;
